/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { Expedition, ExpeditionInterface } from "../Expedition";

const _abi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "charactersStartTime_",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "seasons_",
        type: "address",
        internalType: "address",
      },
      {
        name: "oracle_",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addLocation",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "startTime",
        type: "uint40",
        internalType: "uint40",
      },
      {
        name: "minDuration",
        type: "uint40",
        internalType: "uint40",
      },
      {
        name: "maxDuration",
        type: "uint40",
        internalType: "uint40",
      },
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "createLocationData",
        type: "tuple",
        internalType: "struct IExpedition.CreateLocationData",
        components: [
          {
            name: "rewardTokens",
            type: "tuple[]",
            internalType: "struct IExpedition.RewardToken[]",
            components: [
              {
                name: "tokenAddress",
                type: "address",
                internalType: "address",
              },
              {
                name: "minAmount",
                type: "int256",
                internalType: "int256",
              },
              {
                name: "maxAmount",
                type: "int256",
                internalType: "int256",
              },
            ],
          },
          {
            name: "locationEventTypeConfig",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
          {
            name: "locationExtraConfig",
            type: "uint32[]",
            internalType: "uint32[]",
          },
          {
            name: "locationEventTypeDistribution",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "locationStackSizesConfig",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewInterpreterVersion",
    inputs: [
      {
        name: "interpreter",
        type: "address",
        internalType: "address",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewLocationEventTypeConfig",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "locationEventTypeConfig",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewLocationEventTypeDistribution",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "locationEventTypeDistribution",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewLocationExtraConfig",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "locationExtraConfig",
        type: "uint32[]",
        internalType: "uint32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewLocationStackSizes",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "locationStackSizesConfig",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "addNewRewardTokensVersionToLocation",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "rewardTokens",
        type: "tuple[]",
        internalType: "struct IExpedition.RewardToken[]",
        components: [
          {
            name: "tokenAddress",
            type: "address",
            internalType: "address",
          },
          {
            name: "minAmount",
            type: "int256",
            internalType: "int256",
          },
          {
            name: "maxAmount",
            type: "int256",
            internalType: "int256",
          },
        ],
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimExpedition",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getCharacters",
    inputs: [
      {
        name: "user",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "characters",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getCharactersStartTime",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getExpeditionState",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "expeditionSlot",
        type: "tuple",
        internalType: "struct IExpedition.ExpeditionSlot",
        components: [
          {
            name: "locationId",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "user",
            type: "address",
            internalType: "address",
          },
          {
            name: "startTimestamp",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "duration",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "interruptedDuration",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "claimed",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "interpreter",
            type: "address",
            internalType: "address",
          },
        ],
      },
      {
        name: "expeditionStates",
        type: "tuple[]",
        internalType: "struct IExpedition.ExpeditionIntermediateState[]",
        components: [
          {
            name: "eventTime",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "status",
            type: "uint8",
            internalType: "enum IExpedition.ExpeditionStatus",
          },
          {
            name: "aliveCharacters",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
          {
            name: "deadCharacters",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
          {
            name: "inventory",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
          {
            name: "eventVariation",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getInterpreterByTimestamp",
    inputs: [
      {
        name: "timestamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "interpreter",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getInterpreterByVersion",
    inputs: [
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "interpreter",
        type: "address",
        internalType: "address",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getInterpreterLatestVersion",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLatestExpeditionId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocation",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "startTime",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "minDuration",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "maxDuration",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeConfigByTimestamp",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "timeStamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationEventTypeConfig",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeConfigByVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationEventTypeConfig",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeConfigLatestVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeDistributionByTimestamp",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "timeStamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationEventTypeDistribution",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeDistributionByVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationEventTypeDistribution",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationEventTypeDistributionLatestVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationExtraConfigByTimestamp",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "timeStamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationExtraConfig",
        type: "uint32[]",
        internalType: "uint32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationExtraConfigByVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationExtraConfig",
        type: "uint32[]",
        internalType: "uint32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationExtraConfigLatestVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationRewardTokensByTimestamp",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "timeStamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "rewardTokens",
        type: "tuple[]",
        internalType: "struct IExpedition.RewardToken[]",
        components: [
          {
            name: "tokenAddress",
            type: "address",
            internalType: "address",
          },
          {
            name: "minAmount",
            type: "int256",
            internalType: "int256",
          },
          {
            name: "maxAmount",
            type: "int256",
            internalType: "int256",
          },
        ],
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationRewardTokensByVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "rewardTokens",
        type: "tuple[]",
        internalType: "struct IExpedition.RewardToken[]",
        components: [
          {
            name: "tokenAddress",
            type: "address",
            internalType: "address",
          },
          {
            name: "minAmount",
            type: "int256",
            internalType: "int256",
          },
          {
            name: "maxAmount",
            type: "int256",
            internalType: "int256",
          },
        ],
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationStackSizesByTimestamp",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "timeStamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationStackSizes",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationStackSizesByVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "version",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "locationStackSizes",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
      {
        name: "startsFrom",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getLocationStackSizesLatestVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getRewardTokensLatestVersion",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getSeasonPointsForExpedition",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "seasonPoints",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getSeasonPointsMultiplier",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "start",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "fixPerStep",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "outerMultiplier",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getTokensForPay",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "duration",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "characters",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
    ],
    outputs: [
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getUserExpeditionSlots",
    inputs: [
      {
        name: "user",
        type: "address",
        internalType: "address",
      },
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "slots",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "interpreter",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "interruptExpedition",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "isConsumeTokenListed",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "tokenAddress",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isOperator",
    inputs: [
      {
        name: "operator",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "parseLoot",
    inputs: [
      {
        name: "loot",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
    ],
    outputs: [
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setSeasonPointsMultiplier",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "start",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "fixPerStep",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "outerMultiplier",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "startExpedition",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "characterIndexes",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "duration",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "toggleConsumesToken",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "consumesToken",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "toggleOperator",
    inputs: [
      {
        name: "operator",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "updateLocationMinAndMaxDurations",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "minDuration",
        type: "uint40",
        internalType: "uint40",
      },
      {
        name: "maxDuration",
        type: "uint40",
        internalType: "uint40",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "updateLocationPriceTokens",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "tokens",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "updateLocationStartTime",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "startTime",
        type: "uint40",
        internalType: "uint40",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "ConsumeTokenToggled",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "tokenAddress",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "newValue",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ExpeditionEnded",
    inputs: [
      {
        name: "user",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "expeditionId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ExpeditionInterrupted",
    inputs: [
      {
        name: "user",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "expeditionId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ExpeditionStarted",
    inputs: [
      {
        name: "user",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "expeditionId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint8",
        indexed: false,
        internalType: "uint8",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationEventTypeConfigAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationEventTypeDistributionAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationExtraConfigAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationStackSizesConfigAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LocationUpdated",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OperatorToggled",
    inputs: [
      {
        name: "operator",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "newValue",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardTokensAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetInterpreterAndTimestamp",
    inputs: [
      {
        name: "interpreter",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "startsFrom",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "Expedition_AlreadyClaimed",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_ArrayCannotBeEmpty",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_ArrayLengthMismatch",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_AtLeastOneEventMustBeAchievedBeforeInterrupt",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_CallerIsNotExpeditionOwner",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_CannotInterruptClaimedExpedition",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_CharacterAlreadyUsed",
    inputs: [
      {
        name: "index",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_CharacterIndexesArrayCannotBeEmpty",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_CharacterIndexesArrayNotSorted",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_CharacterIndexesArrayTooLong",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_CharactersStartTimeMustBeMultipleOf30Minutes",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_ExpeditionAlreadyInterrupted",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_ExpeditionAlreadyPassed",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_ExpeditionDoesNotExist",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_ExpeditionNotPassed",
    inputs: [
      {
        name: "expeditionId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_InvalidDuration",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_InvalidMinOrMaxDuration",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_InvalidRewardTokensConfig",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_InvalidStartTime",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_InvalidStartsFrom",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_LocationAlreadyAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_LocationNotAdded",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_LocationNotAvailableYet",
    inputs: [
      {
        name: "locationId",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "error",
    name: "Expedition_MaxCannotBeNegative",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_NoFreeSlots",
    inputs: [],
  },
  {
    type: "error",
    name: "Expedition_RewardTokenMinAmountGreaterThanMax",
    inputs: [],
  },
  {
    type: "error",
    name: "Ownable_NewOwnerCannotBeAddressZero",
    inputs: [],
  },
  {
    type: "error",
    name: "Ownable_SenderIsNotOwner",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
    ],
  },
] as const;

export class Expedition__factory {
  static readonly abi = _abi;
  static createInterface(): ExpeditionInterface {
    return new Interface(_abi) as ExpeditionInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Expedition {
    return new Contract(address, _abi, runner) as unknown as Expedition;
  }
}
